import { render } from "./TargetsEditor.vue?vue&type=template&id=5b69cf80&scoped=true"
import script from "./TargetsEditor.vue?vue&type=script&lang=js"
export * from "./TargetsEditor.vue?vue&type=script&lang=js"

import "./TargetsEditor.vue?vue&type=style&index=0&id=5b69cf80&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b69cf80"]])

export default __exports__